var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password_stength"},[_c('div',{class:{ weak: _vm.classLevel >= 1 }}),_c('div',{class:{ medium: _vm.classLevel >= 2 }}),_c('div',{class:{ strong: _vm.classLevel >= 3 }})])
}
var staticRenderFns = []

export { render, staticRenderFns }